<ph-select [items]="selectItems"
           [value]="selectedKey"
           [placeholder]="placeholder || (statesOnly ? 'State' : '-- Select --')"
           [disabled]="disabled || readonly || boundControl?.disabled"
           aria-label="select state"
           (ph-change)="onRegionSelected($event.detail)"></ph-select>
